<template>
  <div>
    <nav id="navigation" class="jb_emp_navigation  web_navigation">
        <ul id="responsive">
            <li><b-link href="" :to="{name: 'HomeNew'}" class="without_sub_a">{{ $t('nav.home') }}</b-link></li>
            <li class="current_web_nav"><b-link href="#" class="without_sub_a current_an dropdown_custom_arrow" :class="$route.fullPath=='/' ? 'coloured_dropdown' : 'non_coloured_dropdown'">{{ $t('nav.for_jobseeker') }}</b-link>
            <ul class="dropdown-nav router_current_link_with_anchor">
                <li><b-link href="" :to="{name: 'jobseekers3'}">{{ $t('nav.jobseekers') }}</b-link></li>
                <!-- <li><b-link href="" :to="{name: 'signup'}">Signup</b-link></li>
                <li><b-link href="" :to="{name: 'login'}">Login</b-link></li> -->
                <li><b-link href="" :to="{name: 'allDailyPaidJoblisting'}">{{ $t('nav.part_time_jobs') }}</b-link></li>
                <li><b-link href="" :to="{name: 'allJobsListing'}">{{ $t('nav.full_time_jobs') }}</b-link></li>
                <li><b-link href="" to="/singapore-gig-mission">{{ $t('nav.gig_listings') }}</b-link></li>
               <li><b-link href="" :to="{ name: 'ResumeBuilder' }" target=_blank>{{ $t('nav.resume_builder') }}</b-link></li>
            </ul>
            </li>
            <li><b-link href="" :to="{name: 'employer3'}" class="without_sub_a">{{ $t('nav.for_employer') }}</b-link></li>
            <li><b-link href="" :to="{name: 'GigMissionsLanding'}">{{ $t('nav.gig_missions') }}</b-link></li>
            <!-- <li><b-link :to="{ name: 'Rewards' }"><span>Rewards</span></b-link></li> -->
             <li><b-link href="" :to="{name: 'blog'}" class="without_sub_a">{{ $t('nav.blog') }}</b-link></li>
             <li><b-link href="" :to="{name: 'aboutUs'}" class="without_sub_a">{{ $t('nav.about_us') }}</b-link></li>
        </ul>
    </nav>
  </div>
</template>

<script>

export default{
    props: {
        is_gig: {
            type: Boolean,
            default: false
        }
    },
    data() {
		return {
            webUrl: process.env.VUE_APP_URL
        }
	},
	methods:{

	},
    components:{

    },
	mounted()
    {

    }
}

</script>
